import React, { useState } from 'react'
import useRippleEffect from '../hooks/useRippleEffect';
// Components
import PageTransition from '../components/PageTransition';
// CSS
import '../assets/css/form-page.css';

export default function ForgetPassword() {
  const [page, setPage] = useState(1);
  useRippleEffect();

  function setCurrentPage(key){
    setPage(key)
  }

  return (
    <div className="form_page forget_password_page page_body">
      <PageTransition />
      <div className="container">
        {
          page === 1?
          <form className="form_primary form-1">
            <div className="header">
              {/* <div className="branding select_n">
                <img src={Branding} alt="CodoHov" />
              </div> */}
              <div className="form_title">Forget Password</div>
            </div>
            <div className="inputs">
              <div className="input_container">
                <label className="form_label" htmlFor="email">Account Email</label>
                <input type="email" id="email" className="form_input" placeholder="Email" required />
              </div>
            </div>
            <div className="actions">
              <button className="btn_primary bg-1 ripple-animate ripple-dark" type="button" onClick={() => {setCurrentPage(2)}}>Continue</button>
            </div>
          </form>
          :
          page === 2?
          <form className="form_primary form-2">
            <div className="header">
              {/* <div className="branding select_n">
                <img src={Branding} alt="CodoHov" />
              </div> */}
              <div className="form_title">Forget Password</div>
            </div>
            <div className="inputs">
              <div className="input_container">
                <label className="form_label select_n brd-bottom">Recovery Info</label>
                <p>We will send you a confirmation code on your email md***********@gmail.com Click on the button below to get the code.</p>
              </div>
            </div>
            <div className="actions">
              <button className="btn_primary bg-1 ripple-animate ripple-dark w-100" type="button" onClick={() => {setCurrentPage(3)}}>Get Code</button>
            </div>
          </form>
          :
          page === 3?
          <form className="form_primary form-3">
            <div className="header">
              {/* <div className="branding select_n">
                <img src={Branding} alt="CodoHov" />
              </div> */}
              <div className="form_title">Forget Password</div>
            </div>
      
            <div className="inputs">
              <div className="input_container">
                <lable className="form_label brd-bottom" htmlFor="verification-code">Verification Code</lable>
                <p>We have sent a verification code to your email md***********@gmail.com Enter to code here to continue.</p>
                <input className="form_input" type="text" id="verification-code" placeholder="Verification Code" required />
              </div>
            </div>
      
            <div className="actions">
              <button className="btn_primary ripple-animate ripple-dark bg-1" type="button" onClick={() => {setCurrentPage(4)}}>Verfiy</button>
            </div>
          </form>
          :
          <form className="form_primary">
            <div className="header">
              {/* <div className="branding select_n">
                <img src={Branding} alt="CodoHov" />
              </div> */}
              <div className="form_title">Create New Password</div>
            </div>
      
            <div className="inputs">
              <div className="input_container">
                <lable className="form_label" htmlFor="password">New Password</lable>
                <input className="form_input" type="password" id="password" placeholder="******" required />
              </div>
              <div className="input_container">
                <lable className="form_label" htmlFor="confirm-password">Confirm Password</lable>
                <input className="form_input" type="password" id="confirm-password" placeholder="******" required />
              </div>
            </div>
      
            <div className="actions">
              <button className="btn_primary ripple-animate ripple-dark bg-1 w-100" type="button" onClick={() => {setCurrentPage(1)}}>Change Password</button>
            </div>
          </form>
        }
      </div>
    </div>
  )
}
